import { Button } from "@/components/ui/button";
import { HelpCircle, Wand2, SkipForward } from "lucide-react";
import { useGame } from "@/contexts/GameContext";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export default function TaskTypeSelection({ onSelect, onSkip }) {
  const { state } = useGame();
  // Jeśli nie ma wybranego gracza, użyj obecnego
  const targetPlayerIndex =
    state.selectedPlayerIndex ?? state.currentPlayerIndex;
  const targetPlayer = state.players[targetPlayerIndex];

  if (!targetPlayer) {
    return (
      <div className="text-center text-xl">Błąd: Nie znaleziono gracza.</div>
    );
  }

  return (
    <main className="py-16 text-center space-y-4 w-full flex flex-col justify-center items-center">
      {/* Informacja o graczu */}
      <div className="flex flex-col items-center gap-4">
        <Avatar className="w-24 h-24 border-4 border-white/20 shadow-lg">
          <AvatarFallback className="text-4xl font-bold bg-gradient-to-r from-pink-500 to-purple-600">
            {targetPlayer.name.charAt(0).toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <h2 className="text-3xl font-bold">{targetPlayer.name}, wybieraj:</h2>
      </div>

      {/* Przyciski Wyboru */}
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Przycisk Prawda */}
        <Button
          variant="outline"
          onClick={() => onSelect("pytanie")}
          className="
                    p-6 h-auto rounded-3xl border-2 transition-all duration-300 ease-in-out
                    flex flex-col items-center justify-center gap-4
                    text-center group backdrop-blur-sm bg-black/10 border-blue-400/50 shadow-sm shadow-blue-400/20
                "
        >
          <HelpCircle className="size-7 text-blue-300 transition-colors" />
          <span className="font-bold text-lg">Prawda</span>
        </Button>

        {/* Przycisk Wyzwanie */}
        <Button
          variant="outline"
          onClick={() => onSelect("wyzwanie")}
          className="
                    p-6 h-auto rounded-3xl border-2 transition-all duration-300 ease-in-out
                    flex flex-col items-center justify-center gap-4
                    text-center group backdrop-blur-sm bg-background/10 border-red-400/50 shadow-sm shadow-red-400/20
                "
        >
          <Wand2 className="size-7 text-red-500 dark:text-red-300 transition-colors" />
          <span className="font-bold text-lg">Wyzwanie</span>
        </Button>
      </div>

      {/* Przycisk Pomiń (Opcjonalny) */}
      <Button
        onClick={onSkip}
        size="lg"
        variant="outline"
        className="border-dashed hover:border-solid"
      >
        <SkipForward className="w-4 h-4" />
        Pomiń kolejkę
      </Button>
    </main>
  );
}
